import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {SLICE_BASE_NAME} from './constants'

export type RoleState = {
    id: number,
    name?: string
    permissions: string[]
    layoutType: number
}

const initialState: RoleState = {
    id: 0,
    name: '',
    permissions: [],
    layoutType: 2,
}

const roleSlice = createSlice({
    name: `${SLICE_BASE_NAME}/role`,
    initialState,
    reducers: {
        setRole(state, action: PayloadAction<RoleState>) {
            state.id = action.payload?.id
            state.name = action.payload?.name
            state.permissions = action.payload?.permissions
            state.layoutType = action.payload?.layoutType
        },
    },
})

export const {setRole} = roleSlice.actions
export default roleSlice.reducer
